import React from "react";
import { useState, useEffect } from "react";
import FinancialIncomeCard from "./components/FinancialIncomeCard";
import IncomeBreakdownCards from "./components/IncomeBreakdownCard";
import IncomeDistributionPieChart from "../common/IncomeDistributionPieChart";
import IncomeBarChart from "../common/IncomeBarChart";
import FinancialStatementTable from "./components/FinancialStatementTable";
import SpinnerLoader from "../../../../presentationals/Loader/Loader.component";
// import SpinnerLoader from "../../../Component/Common/Loader.component";
import { getDisbursalData } from "../API's/Actioncreator";
import moment from "moment";
function Financial({ selectedMonth, commonFilter }) {
  const [financialData, setFinancialData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  console.log("loading", loading);
  console.log("financialData", financialData);

  useEffect(() => {
    if (selectedMonth && selectedMonth?.length > 0) {
      setLoading(true);
      setError(null);

      const monthMap = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3,
        May: 4, Jun: 5, Jul: 6, Aug: 7,
        Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      const sortedMonths = [...selectedMonth]?.sort((a, b) => {
        const [mA, yA] = a.split(" ");
        const [mB, yB] = b.split(" ");

        return new Date(yA, monthMap[mA]) - new Date(yB, monthMap[mB]);
      });

      const [startMonthName, startYear] = sortedMonths?.[0]?.split(" ");
      const [endMonthName, endYear] =
        sortedMonths[sortedMonths.length - 1]?.split(" ");

      const startMonthIndex = monthMap[startMonthName];
      const endMonthIndex = monthMap[endMonthName];

      // const startDate = `01-${String(startMonthIndex + 1)?.padStart(2, "0")}-${startYear}`;

      const lastDay = new Date(endYear, endMonthIndex + 1, 0)?.getDate();
      // const endDate = `${lastDay}-${String(endMonthIndex + 1)?.padStart(2, "0")}-${endYear}`;

      const startDate = moment(commonFilter?.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY");
      const endDate = moment(commonFilter?.toDate, "YYYY-MM-DD").format("DD-MM-YYYY");

      getDisbursalData(
        startDate,

        endDate,commonFilter?.nbfc ?? "",

        (response) => {
          console.log("collection summary", response);

          setLoading(false);

          if (response?.status === 200 && response?.data) {
            setFinancialData(response?.data);
          }
        },

        (error) => {
          console.log("error", error);

          setLoading(false);
        },
      );
    }
  }, [selectedMonth, commonFilter]);

  if (loading) {
    return <SpinnerLoader />;
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '400px',
        color: '#E7000B',
        fontSize: '16px'
      }}>
        {error}
      </div>
    );
  }
  return (
    <div>
      <FinancialIncomeCard data={financialData} />
      <IncomeBreakdownCards data={financialData} />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: window.innerWidth > 1800 ? "30px" : "20px",
          marginTop: window.innerWidth > 1800 ? "30px" : "20px",

        }}
      >
        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "14px",
            padding: "20px",
            // boxShadow:
            //   "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
            boxShadow:
              "0px 1px 1px rgba(0,0,0,0.08), 0px 1px 2px rgba(0,0,0,0.06)",
          }}
        >
          <IncomeDistributionPieChart
            title="Income Distribution"
            labels={["Principal", "Interest", "Processing Fee", "Charges"]}
            series={[
              financialData?.financialBreakdown?.principal?.percentage || 0,

              financialData?.financialBreakdown?.interest?.percentage || 0,

              financialData?.financialBreakdown?.processingFee?.percentage || 0,

              financialData?.financialBreakdown?.charges?.percentage || 0,
            ]}
          />
        </div>

        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "14px",
            padding: "20px",

            boxShadow:
              "0px 1px 1px rgba(0,0,0,0.08), 0px 1px 2px rgba(0,0,0,0.06)",
          }}
        >
          <IncomeBarChart
            title="Income Components Comparison"
            gridType="horizontal"
            categories={["Principal", "Interest", "Processing Fee", "Charges"]}
            series={[
              {
                name: "Income",

                data: [
                  financialData?.financialBreakdown?.principal?.amount || 0,

                  financialData?.financialBreakdown?.interest?.amount || 0,

                  financialData?.financialBreakdown?.processingFee?.amount || 0,

                  financialData?.financialBreakdown?.charges?.amount || 0,
                ],
              },
            ]}
            yType="currency"
            currencySymbol="₹"
          />
        </div>
      </div>
      <FinancialStatementTable data={financialData} />
    </div>
  );
}

export default Financial;
